module.exports = __webpack_public_path__ + "static/media/logo-icon.e634286b.svg";